import React, { useCallback, useMemo, useState } from "react";
import { nanoid } from "nanoid";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import styles from "assets/jss/material-dashboard-pro-react/components/tasksStyle.js";
import * as _ from "lodash";
// @ts-ignore
const useStyles = makeStyles(styles);

interface IProps {
  name?: string;
  isDistributor?: boolean;
  menus: {
    action: () => void;
    name: string;
    menuItem?: React.ReactNode;
    hidden?: boolean;
    props?: any;
  }[];
}
const HoverDropdown: React.FC<IProps> = ({ name, menus, isDistributor }) => {
  const classes = useStyles();
  const getKey = useCallback(
    (str: any, idx: any) => encodeURI(`${str},${idx}`),
    []
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const menuId = useMemo(() => `hover-dropdown-${nanoid()}`, []);

  const handleToggle = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl((prev) => (prev ? null : event.currentTarget));
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const visibleMenus = menus.filter((menu) => !menu.hidden);

  return (
    <>
      {!_.isEmpty(visibleMenus) ? (
        <div
          className={`${classes.iconWrapper} ${
            isDistributor ? classes.iconWrapperHover : ""
          }`}
        >
          <IconButton
            aria-label="more"
            aria-controls={menuId}
            aria-haspopup="true"
            className={classes.tableActionButton}
            onClick={handleToggle}
            style={isDistributor ? { opacity: 0.3, pointerEvents: "none" } : {}}
          >
            <MoreVertIcon />
          </IconButton>
          {isDistributor && (
            <span className={classes.stopSign} role="img" aria-label="Stop">
              🚫
            </span>
          )}
        </div>
      ) : (
        <div />
      )}
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          style: {
            maxHeight: "min(70vh, 420px)",
          },
        }}
      >
        {menus.map((item, index) => {
          if (item.hidden) {
            return null;
          }
          const runAction = () => {
            item.action();
            handleClose();
          };
          const props = item.props
            ? {
                ...item.props,
                onClick: (e: React.MouseEvent<HTMLElement>) => {
                  if (typeof item.props.onClick === "function") {
                    item.props.onClick(e);
                  }
                  handleClose();
                },
              }
            : { onClick: runAction };
          return !item.menuItem ? (
            <MenuItem
              key={nanoid() + getKey(index, item.name) + name}
              {...props}
            >
              {item.name}
            </MenuItem>
          ) : (
            <div key={nanoid() + getKey(index, item.name)}>
              {item.menuItem}
            </div>
          );
        })}
      </Menu>
    </>
  );
};

export default HoverDropdown;
